import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class DescriptionColumn extends Column {
    title = 'time-off-v3.description';
    property = 'description';
    type: CellDisplay = CellDisplay.string;
}
